import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import './SiteFooter.css';

const accountLinks = [
  { labelKey: 'footer.orderHistory', to: '/user/orders' },
  { labelKey: 'account.wishlist', to: '/user/wishlist' },
  { labelKey: 'account.paymentMethods', to: '/user/payments' },
  { labelKey: 'account.deliveryAddresses', to: '/user/addresses' },
];

const usefulLinks = [
  { labelKey: 'footer.aboutUs', to: '/about-us' },
  { labelKey: 'footer.termsConditions', to: '/terms-and-conditions' },
  { labelKey: 'footer.privacyPolicy', to: '/privacy-policy' },
];

const FacebookIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M14 8h2V4h-2.8C10.5 4 9 5.6 9 8.2V10H7v4h2v6h4v-6h2.4l.6-4h-3V8.7c0-.5.3-.7 1-.7Z" />
  </svg>
);

const InstagramIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <rect x="5" y="5" width="14" height="14" rx="4" />
    <circle cx="12" cy="12" r="3.3" />
    <circle cx="16.2" cy="7.8" r="0.8" />
  </svg>
);

const TikTokIcon = () => (
  <svg className="site-footer__social-icon--tiktok" viewBox="0 0 24 24" aria-hidden="true">
    <path d="M15.4 3c.4 2.5 1.8 4.1 4.4 4.3v3.2a7.4 7.4 0 0 1-4.2-1.3v6.1c0 3.1-2 5.7-5.3 5.7A5.3 5.3 0 0 1 5 15.7c0-3.3 2.6-5.4 5.8-5.4.4 0 .7 0 1.1.1v3.3a3 3 0 0 0-1.1-.2c-1.4 0-2.4.9-2.4 2.2 0 1.4 1 2.2 2.2 2.2 1.5 0 2.1-.9 2.1-2.5V3h2.7Z" />
  </svg>
);

const SiteFooter = () => {
  const { t } = useLanguage();

  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <section className="site-footer__column site-footer__column--wide">
          <h3>{t('footer.about')}</h3>
          <p>{t('footer.aboutText')}</p>
        </section>

        <section className="site-footer__column">
          <h3>{t('footer.contactInfo')}</h3>
          <ul>
            <li>{t('footer.address')}</li>
            <li>{t('footer.addressSecondary')}</li>
            <li>{t('footer.email')}</li>
          </ul>
          <p className="site-footer__social-heading">{t('footer.socialHeading')}</p>
          <div className="site-footer__socials" aria-label={t('footer.socialLinks')}>
            <a href="https://www.facebook.com/sifrifanageorgia" target="_blank" rel="noreferrer" aria-label="Facebook">
              <FacebookIcon />
            </a>
            <a href="https://www.instagram.com/sifrifana.ge?igsh=YjNrbjR6Yjdvcmtv" target="_blank" rel="noreferrer" aria-label="Instagram">
              <InstagramIcon />
            </a>
            <a href="https://www.tiktok.com/@sifrifanagifts?_r=1&_t=ZS-96Ft8OzuLXl" target="_blank" rel="noreferrer" aria-label="TikTok">
              <TikTokIcon />
            </a>
          </div>
        </section>

        <section className="site-footer__column">
          <h3>{t('footer.myAccount')}</h3>
          <ul>
            {accountLinks.map((item) => (
              <li key={item.to}>
                <Link to={item.to}>{t(item.labelKey)}</Link>
              </li>
            ))}
          </ul>
        </section>

        <section className="site-footer__column">
          <h3>{t('footer.usefulLink')}</h3>
          <ul>
            {usefulLinks.map((item) => (
              <li key={item.to}>
                <Link to={item.to}>{t(item.labelKey)}</Link>
              </li>
            ))}
          </ul>
        </section>
      </div>

      <div className="site-footer__bottom">
        <p>{t('footer.rights')}</p>
        <Link to="/terms-and-conditions">{t('footer.terms')}</Link>
        <Link to="/privacy-policy">{t('footer.privacyPolicy')}</Link>
      </div>
    </footer>
  );
};

export default SiteFooter;
